import Routes from '@/router/Routes.ts';

// Navigation for Family Members
export const familyMemberNavData = [
  {
    title: 'navbar.carers',
    path: Routes.CARERS,
    icon: (
      <img
        src="/assets/carers.svg"
        alt="carers"
        className="w-4 h-4 transition-[filter] duration-150 group-hover:brightness-0 group-hover:invert group-data-[active=true]:brightness-0 group-data-[active=true]:invert"
      />
    ),
  },
  {
    title: 'navbar.messages',
    path: Routes.MESSAGES,
    icon: (
      <img
        src="/assets/messages.svg"
        alt="messages"
        className="w-4 h-4 transition-[filter] duration-150 group-hover:brightness-0 group-hover:invert group-data-[active=true]:brightness-0 group-data-[active=true]:invert"
      />
    ),
  },
  {
    title: 'navbar.booking',
    path: Routes.BOOKING,
    icon: (
      <img
        src="/assets/bookings.svg"
        alt="bookings"
        className="w-4 h-4 transition-[filter] duration-150 group-hover:brightness-0 group-hover:invert group-data-[active=true]:brightness-0 group-data-[active=true]:invert"
      />
    ),
  },
  {
    title: 'navbar.introCalls',
    path: Routes.INTRO_CALLS,
    icon: (
      <img
        src="/assets/call.svg"
        alt="intro calls"
        className="w-4 h-4 transition-[filter] duration-150 group-hover:brightness-0 group-hover:invert group-data-[active=true]:brightness-0 group-data-[active=true]:invert"
      />
    ),
  },
  {
    title: 'navbar.faq',
    path: Routes.FAQ,
    icon: (
      <img
        src="/assets/faq.svg"
        alt="faq"
        className="w-4 h-4 transition-[filter] duration-150 group-hover:brightness-0 group-hover:invert group-data-[active=true]:brightness-0 group-data-[active=true]:invert"
      />
    ),
  },
  {
    title: 'navbar.settings',
    path: Routes.SETTINGS,
    icon: (
      <img
        src="/assets/settings.svg"
        alt="settings"
        className="w-4 h-4 transition-[filter] duration-150 group-hover:brightness-0 group-hover:invert group-data-[active=true]:brightness-0 group-data-[active=true]:invert"
      />
    ),
  },
];

// Navigation for Business Providers
export const businessProviderNavData = [
  {
    title: 'navbar.introCalls',
    path: Routes.INTRO_CALLS,
    icon: (
      <img
        src="/assets/call.svg"
        alt="intro calls"
        className="w-4 h-4 transition-[filter] duration-150 group-hover:brightness-0 group-hover:invert group-data-[active=true]:brightness-0 group-data-[active=true]:invert"
      />
    ),
  },
  {
    title: 'navbar.myBookings',
    path: Routes.BOOKING,
    icon: (
      <img
        src="/assets/bookings.svg"
        alt="my bookings"
        className="w-4 h-4 transition-[filter] duration-150 group-hover:brightness-0 group-hover:invert group-data-[active=true]:brightness-0 group-data-[active=true]:invert"
      />
    ),
  },
  {
    title: 'navbar.messages',
    path: Routes.MESSAGES,
    icon: (
      <img
        src="/assets/messages.svg"
        alt="messages"
        className="w-4 h-4 transition-[filter] duration-150 group-hover:brightness-0 group-hover:invert group-data-[active=true]:brightness-0 group-data-[active=true]:invert"
      />
    ),
  },
  {
    title: 'navbar.documents',
    path: Routes.DOCUMENTS,
    icon: (
      <img
        src="/assets/faq.svg"
        alt="documents"
        className="w-4 h-4 transition-[filter] duration-150 group-hover:brightness-0 group-hover:invert group-data-[active=true]:brightness-0 group-data-[active=true]:invert"
      />
    ),
  },
  {
    title: 'navbar.faq',
    path: Routes.FAQ,
    icon: (
      <img
        src="/assets/faq.svg"
        alt="faq"
        className="w-4 h-4 transition-[filter] duration-150 group-hover:brightness-0 group-hover:invert group-data-[active=true]:brightness-0 group-data-[active=true]:invert"
      />
    ),
  },
  {
    title: 'navbar.settings',
    path: Routes.SETTINGS,
    icon: (
      <img
        src="/assets/settings.svg"
        alt="settings"
        className="w-4 h-4 transition-[filter] duration-150 group-hover:brightness-0 group-hover:invert group-data-[active=true]:brightness-0 group-data-[active=true]:invert"
      />
    ),
  },
];

// Navigation for Admin
export const adminNavData = [
  {
    title: 'Families',
    path: Routes.ADMIN_FAMILIES,
    icon: (
      <img
        src="/assets/family.svg"
        alt="families"
        className="w-4 h-4 transition-[filter] duration-150 group-hover:brightness-0 group-hover:invert group-data-[active=true]:brightness-0 group-data-[active=true]:invert"
      />
    ),
  },
  {
    title: 'Carers',
    path: Routes.ADMIN_CARERS,
    icon: (
      <img
        src="/assets/heart.svg"
        alt="carers"
        className="w-4 h-4 transition-[filter] duration-150 group-hover:brightness-0 group-hover:invert group-data-[active=true]:brightness-0 group-data-[active=true]:invert"
      />
    ),
  },
  {
    title: 'Requests',
    path: Routes.ADMIN_REQUESTS,
    icon: (
      <img
        src="/assets/requests.svg"
        alt="requests"
        className="w-4 h-4 transition-[filter] duration-150 group-hover:brightness-0 group-hover:invert group-data-[active=true]:brightness-0 group-data-[active=true]:invert"
      />
    ),
  },
  {
    title: 'Bookings',
    path: Routes.ADMIN_BOOKINGS,
    icon: (
      <img
        src="/assets/bookings.svg"
        alt="bookings"
        className="w-4 h-4 transition-[filter] duration-150 group-hover:brightness-0 group-hover:invert group-data-[active=true]:brightness-0 group-data-[active=true]:invert"
      />
    ),
  },
  {
    title: 'navbar.settings',
    path: Routes.SETTINGS,
    icon: (
      <img
        src="/assets/settings.svg"
        alt="settings"
        className="w-4 h-4 transition-[filter] duration-150 group-hover:brightness-0 group-hover:invert group-data-[active=true]:brightness-0 group-data-[active=true]:invert"
      />
    ),
  },
];

// Default export for backward compatibility
export const navData = familyMemberNavData;
